import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavBarComponent } from './components/nav-bar.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        NavBarComponent,
    ],
    exports: [
        NavBarComponent
    ],
    providers: [
        {
            provide: 'Document',
            useValue: document,
        },
    ],
})

export class NavBarModule {}
